import { Component, input } from '@angular/core';

@Component({
  selector: 'b2c-icon',
  styleUrl: './icon.component.scss',
  templateUrl: './icon.component.html',
})
export class IconComponent {
  icon = input<string>('');
  buttonTitle = input.required<string>();
  imgWidth = input<string>('auto');
  disabled = input<boolean>(false);
  unselectImgWidth = input<string>('');
}
